import { createSignal } from "solid-js";
import { getToken } from "../api/client";

export const [selectedId, setSelectedId] = createSignal<number | null>(null);
export const [sidePanelOpen, setSidePanelOpen] = createSignal(false);
export const [paletteOpen, setPaletteOpen] = createSignal(false);
export const [quickAddOpen, setQuickAddOpen] = createSignal(false);

// Mobile-only sidebar drawer state. On desktop CSS hides the drawer
// behavior entirely; this signal is meaningful only at narrow widths.
export const [drawerOpen, setDrawerOpen] = createSignal(false);

// True when the user has no token, or when a 401 has invalidated the existing
// one. Initialized synchronously so the auth gate renders before any data
// fetch is attempted.
export const [tokenPromptOpen, setTokenPromptOpen] = createSignal(!getToken());

if (typeof window !== "undefined") {
  window.addEventListener("auth:required", () => setTokenPromptOpen(true));
}
